import { render, staticRenderFns } from "./localbranch-style-2.vue?vue&type=template&id=14d62cf1&"
import script from "./localbranch-style-2.vue?vue&type=script&lang=js&"
export * from "./localbranch-style-2.vue?vue&type=script&lang=js&"
import style0 from "./localbranch-style-2.vue?vue&type=style&index=0&id=14d62cf1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports